import { render, staticRenderFns } from "./box-wrapper.vue?vue&type=template&id=4f3720b9&scoped=true&"
import script from "./box-wrapper.vue?vue&type=script&lang=ts&"
export * from "./box-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./box-wrapper.vue?vue&type=style&index=0&id=4f3720b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3720b9",
  null
  
)

export default component.exports